import React from 'react';
import { Github, Globe, Instagram, Linkedin, Twitter } from 'lucide-react';
import { Button } from 'components/Elements';

export const Footer = ({ className = '' }) => {
  return (
    <footer className={`bg-gray-50 dark:bg-gray-900 text-gray-700 dark:text-gray-300 ${className}`}>
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Top Section: Brand + Social */}
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-12">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <h2 className="text-2xl font-bold text-[#F12C00]">Ashita®</h2>
            <p className="max-w-xs text-sm opacity-80">
              Ashita Console: the all-in-one platform for modern businesses to manage payments,
              analytics, workflows, and integrations with ease. Trusted by thousands of companies
              worldwide.
            </p>

            <div className="flex gap-3 mt-2">
              <a
                href="https://ashita.africa"
                target="_blank"
                rel="noreferrer"
                className="p-3 bg-gray-200/20 dark:bg-gray-700/20 rounded-xl border border-gray-200/30 hover:bg-gray-200/30 transition"
              >
                <Globe className="w-5 h-5 text-[#F12C00]" />
              </a>

              <a
                href="https://github.com/ashita"
                target="_blank"
                rel="noreferrer"
                className="p-3 bg-gray-200/20 dark:bg-gray-700/20 rounded-xl border border-gray-200/30 hover:bg-gray-200/30 transition"
              >
                <Github className="w-5 h-5 text-[#F12C00]" />
              </a>

              <a
                href="#"
                className="p-3 bg-gray-200/20 dark:bg-gray-700/20 rounded-xl border border-gray-200/30 hover:bg-gray-200/30 transition"
              >
                <Instagram className="w-5 h-5 text-[#F12C00]" />
              </a>

              <a
                href="#"
                className="p-3 bg-gray-200/20 dark:bg-gray-700/20 rounded-xl border border-gray-200/30 hover:bg-gray-200/30 transition"
              >
                <Linkedin className="w-5 h-5 text-[#F12C00]" />
              </a>

              <a
                href="#"
                className="p-3 bg-gray-200/20 dark:bg-gray-700/20 rounded-xl border border-gray-200/30 hover:bg-gray-200/30 transition"
              >
                <Twitter className="w-5 h-5 text-[#F12C00]" />
              </a>
            </div>
          </div>

          {/* Newsletter Signup */}
          <div className="flex flex-col gap-4 max-w-sm">
            <h3 className="font-semibold text-lg">Subscribe to our newsletter</h3>
            <p className="text-sm opacity-80">
              Get the latest updates, product announcements, and exclusive offers.
            </p>
            <form className="flex flex-col sm:flex-row gap-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="px-4 py-2 rounded-xl border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-amber-400 dark:bg-gray-800 dark:text-gray-200 flex-1"
              />
              <Button type="submit">Subscribe</Button>
            </form>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 dark:border-gray-700 my-12"></div>

        {/* Links Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12">
          {/* Product */}
          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="flex flex-col gap-2 text-sm opacity-80">
              <li>
                <a href="#">Features</a>
              </li>
              <li>
                <a href="#">Integrations</a>
              </li>
              <li>
                <a href="#">Pricing</a>
              </li>
              <li>
                <a href="#">Enterprise</a>
              </li>
              <li>
                <a href="#">API</a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="flex flex-col gap-2 text-sm opacity-80">
              <li>
                <a href="#">About Us</a>
              </li>
              <li>
                <a href="#">Careers</a>
              </li>
              <li>
                <a href="#">Press</a>
              </li>
              <li>
                <a href="#">Blog</a>
              </li>
              <li>
                <a href="#">Contact</a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="flex flex-col gap-2 text-sm opacity-80">
              <li>
                <a href="#">Help Center</a>
              </li>
              <li>
                <a href="#">Guides</a>
              </li>
              <li>
                <a href="#">Community</a>
              </li>
              <li>
                <a href="#">Status</a>
              </li>
              <li>
                <a href="#">Developers</a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="flex flex-col gap-2 text-sm opacity-80">
              <li>
                <a href="#">Privacy Policy</a>
              </li>
              <li>
                <a href="#">Terms of Service</a>
              </li>
              <li>
                <a href="#">Cookie Policy</a>
              </li>
              <li>
                <a href="#">Security</a>
              </li>
              <li>
                <a href="#">Compliance</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="border-t border-gray-200 dark:border-gray-700 mt-12 pt-6 text-center text-sm opacity-70">
          ©2025-2026 Ashita® — All rights reserved. Ashita Holdings Group. Apple, Google Play, and
          other trademarks are property of their respective owners.
        </div>
      </div>
    </footer>
  );
};
